import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  navbarHeader: null,
  navbarActiveItem: null,
  pageHeader: null,
}

export const navbarSlice = createSlice({
  name: 'navbar-header',
  initialState,
  reducers: {
    setNavbarHeader: (state, action) => {
      state.navbarHeader = action.payload
    },
    setNavbarActiveItem: (state, action) => {
      state.navbarActiveItem = action.payload
    },
    setPageHeader: (state, action) => {
      state.pageHeader = action.payload
    },
  },
})

export const { setNavbarHeader, setNavbarActiveItem, setPageHeader } = navbarSlice.actions

export default navbarSlice.reducer
